import { CalendarCheck, UsersRound } from "lucide-react"

import {
  FinanceReportCategory,
  ReportExportKind,
  ReportModule,
  type FinanceReportEntry,
} from "@/features/reports/model/report-registry-types"

/** These reports are new to the PRODUCT, not just to the catalog — nobody could open them before. */
const NEW_UNTIL = "2026-10-31"

/**
 * Reports about ACTIVITIES — what the church ran, and who took part.
 *
 * The money side of an activity is not here. `finance-by-activity`, `activities-by-revenue` and
 * `activities-by-expense` stay in the Finance module, because a treasurer looking for them is looking
 * under Finance. What lives here is participation: the same activity, read as an event rather than a
 * ledger.
 */
function activityEntry(
  id: string,
  category: FinanceReportCategory,
  icon: typeof CalendarCheck,
  keywords: string[],
): FinanceReportEntry {
  return {
    id,
    module: ReportModule.Activities,
    category,
    icon,
    titleKey: `reporting.templates.${id}.title`,
    descriptionKey: `reporting.templates.${id}.description`,
    keywords,
    dataSource: { kind: "engine-template", templateId: id },
    // Reachable for the first time with this release; the badge retires itself on this date.
    newUntil: NEW_UNTIL,
    viewer: { layout: "result-panel", defaultView: "table" },
    export: { kind: ReportExportKind.Engine },
  }
}

export const ACTIVITY_ENTRIES: readonly FinanceReportEntry[] = [
  activityEntry("activity-participation", FinanceReportCategory.Participation, UsersRound, [
    "attendance", "participation", "turnout", "who came",
  ]),
  activityEntry("activities-by-ministry", FinanceReportCategory.Participation, CalendarCheck, [
    "ministry", "activities", "programme", "schedule",
  ]),
]
